( function ( $ ) {
    var Equalite = function (element, settings) {
        var self = this,
            defaults = {
                rangeEntries: [[0, 99999]],
                targetSelector: ".box"
            },
            elem = $(element);

        this.options = $.extend({}, defaults, settings);
        this.elem = elem;
        this.targetBox = elem.find(this.options.targetSelector);


        $(window).on("resize", function () {
            self.update();
        });
        this.update();
    };


    Equalite.prototype.update = function () {
        this.targetBox.css("height", "auto");
        if (this.checkRange(this.elem)) {
            this.equalize();
        }
    };

    Equalite.prototype.checkRange = function () {
        var docWidth = document.documentElement.clientWidth;
        function isValueInRange(value, rangeEntries) {
            var range, i;
            for (i = 0; i < rangeEntries.length; i++) {
                range = rangeEntries[i];
                if (value >= range[0] && value <= range[1]) {
                    return true;
                }
            }
            return false;
        }
        if (isValueInRange(docWidth, this.options.rangeEntries)) {
            return true;
        }
    };

    Equalite.prototype.equalize = function () {
        var a = [],
            targetBox = this.targetBox;
        targetBox.each(function () {
            a.push($(this).outerHeight());
        }).css("height", Math.max.apply(Math, a));
    };

    $.fn.equalite = function (settings) {
        // console.log('this:', this);
        return this.each(function (index, element) {
            new Equalite(element, settings);
        });
    };

} )( window.jQuery );
